import React, { useState, useCallback } from 'react'
import { Field } from 'formik'
import { createUseStyles } from 'react-jss'
import { useSelector } from 'react-redux'
import { getDynamicStyle, getGradientColors } from '../../utils/styles.service'
import { componentStyleSelector } from '../../store/selectors/styles.selector'
import NeoNumber from './NeoNumber/NeoNumber'
import NeoIdentityType from './NeoIdentityType/NeoIdentityType'
import Select from 'react-select'
import NeoOnlyNumber from './NeoNumber/NeoOnlyNumber'
import NeoPassword from './NeoNumber/NeoPassword'
import { useRef } from 'react'
import { useEffect } from 'react'

function NeoInput({
  mode = 'single',
  type,
  name,
  icon,
  text,
  disabled,
  placeholder,
  onChange,
  list,
  keyValue,
  min,
  max,
  onBlur,
  onFocus,
  onClick,
  onKeyPress,
  onKeyDown,
  value,
  waitCondition = true,
  required = false,
  maxLength,
  minLength,
  rows,
  validate,
  options,
  pattern,
  showAsterisk = false,
  tabIndex = '',
}) {
  const componentDynamicStyles = useSelector(componentStyleSelector)
  const inputTextStyles = getDynamicStyle(componentDynamicStyles?.base?.input?.labelInput?.text)
  const inputGradientColors = getGradientColors(
    componentDynamicStyles?.base?.input?.labelInput,
    true,
  )
  const inputStyles = getDynamicStyle(componentDynamicStyles?.base?.input?.labelInput)
  const [passwordVisibility, setPasswordVisibility] = useState(false)

  const useStyles = createUseStyles({
    inputText: {
      ...inputTextStyles,
    },
    inputStyles: {
      ...inputGradientColors,
      ...inputStyles,
    },
  })
  const classes = useStyles()

  const togglePasswordVisibility = useCallback(
    () => setPasswordVisibility(!passwordVisibility),
    [passwordVisibility],
  )

  const onFocusFloat = (name, value) => {
    if (name) {
      var y = document.getElementById('floatingLabel' + name)
      if (y) {
        y.classList.add('label-move-up')
      }
    }
  }

  const onBlurFloat = (name, value) => {
    if (name) {
      var y = document.getElementById('floatingLabel' + name)
      if (y && value == '') {
        y.classList.remove('label-move-up')
      }
    }
  }

  switch (mode) {
    case 'single':
      return (
        <div style={{ ...inputStyles, ...inputGradientColors }}>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <Field
            as='input'
            min={min}
            value={value}
            maxLength={maxLength}
            max={max}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            type={type}
            onChange={onChange}
            onKeyPress={onKeyPress}
            validate={validate}
            onKeyDown={onKeyDown}
            disabled={disabled}
            placeholder={placeholder}
            pattern={pattern}
            tabIndex={tabIndex}
          />
        </div>
      )
    case 'icon':
      return (
        <div>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <Field
            name={name}
            disabled={disabled}
            maxLength={maxLength}
            max={max}
            placeholder={placeholder}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            // placeholder={placeholder}
            onFocus={onFocus}
            // onFocus={onFocus, onFocusFloat(name,value)}
            onBlur={onBlurFloat(name, value)} // ? Note: if obBlur is used it will not not display errors
            type={type}
            as='input'
            autoComplete='off'
            tabIndex={tabIndex}
          />
        </div>
      )
    case 'iconless':
      return (
        <div className='form-group colored-input iconless'>
          {/* <span id={`floatingLabel${name}`} className='floating-label font-weight-500'>{placeholder || text}</span> */}
          <label className='control-label'>
            {text || placeholder} {showAsterisk ? '*' : ''}
          </label>
          <Field
            name={name}
            disabled={disabled}
            maxLength={maxLength}
            max={max}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            placeholder={placeholder}
            onFocus={onFocus}
            // onFocus={onFocus, onFocusFloat(name,value)}
            // onBlur={onBlurFloat(name, value)} // ? Note: if obBlur is used it will not not display errors
            type={type}
            as='input'
            autoComplete='off'
            tabIndex={tabIndex}
          />
        </div>
      )

    case 'select':
      return (
        <div>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <Field
            as='select'
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            disabled={disabled}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={onChange}
            onClick={onClick}
            tabIndex={tabIndex}>
            <option disabled defaultValue value='' />
            {waitCondition ? (
              list !== undefined &&
              list.map((item, i) => (
                <option key={i} value={keyValue ? item[`${keyValue}`] : item}>
                  {keyValue ? item[`${keyValue}`] : item}
                </option>
              ))
            ) : (
              <option disabled value='' />
            )}
          </Field>
        </div>
      )

    case 'search-select': {
      const [searchTerm, setSearchTerm] = useState('')
      const [isDropdownOpen, setIsDropdownOpen] = useState(false)
      const [selectedValue, setSelectedValue] = useState(null)
      const dropdownRef = useRef(null)

      const filteredOptions =
        list?.filter((item) => {
          const optionLabel = keyValue ? item[`${keyValue}`] : item
          return optionLabel.toLowerCase().includes(searchTerm.toLowerCase())
        }) || []
      const handleSearchChange = (e) => {
        setSearchTerm(e.target.value)
        setIsDropdownOpen(true)
      }

      const handleSelectChange = (value) => {
        setSelectedValue(value)
        setIsDropdownOpen(false)
        setSearchTerm('')
        onChange({ target: { name, value } })
      }

      useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false)
          }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
          document.removeEventListener('mousedown', handleClickOutside)
        }
      }, [])

      return (
        <div className='custom-select-wrapper' ref={dropdownRef}>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>

          <div className={`custom-dropdown ${isDropdownOpen ? 'open' : ''}`}>
            <div className='dropdown-header'>
              <input
                type='text'
                placeholder={selectedValue || placeholder}
                className='dropdown-search'
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={() => setIsDropdownOpen(true)}
                tabIndex={tabIndex}
                disabled={disabled}
                onBlur={() => setSearchTerm('')}
              />
            </div>

            {isDropdownOpen && (
              <ul className='dropdown-options'>
                {waitCondition ? (
                  filteredOptions.length > 0 ? (
                    filteredOptions.map((item, i) => (
                      <li
                        key={i}
                        className='dropdown-option'
                        onClick={() => handleSelectChange(keyValue ? item[`${keyValue}`] : item)}>
                        {keyValue ? item[`${keyValue}`] : item}
                      </li>
                    ))
                  ) : (
                    <li className='dropdown-option disabled'>No results found</li>
                  )
                ) : (
                  <li className='dropdown-option disabled'>Loading...</li>
                )}
              </ul>
            )}
          </div>
        </div>
      )
    }
    case 'native-select':
      return (
        <div>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <select
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            value={value}
            onChange={onChange}
            tabIndex={tabIndex}>
            <option disabled value='' />
            {waitCondition ? (
              list.map((item, i) => (
                <option key={i} value={keyValue !== null ? item[`${keyValue}`] : item}>
                  {keyValue ? item[`${keyValue}`] : item}
                </option>
              ))
            ) : (
              <option disabled value='' />
            )}
          </select>
        </div>
      )
    case 'sensitiveIcon':
      return (
        <div>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <div
            className='cursor-pointer suffix'
            style={{ marginTop: '28px' }}
            onClick={togglePasswordVisibility}>
            {passwordVisibility ? (
              <i className='icon material-icons' style={{ width: 15 }}>
                visibility
              </i>
            ) : (
              <i className='icon material-icons' style={{ width: 15 }}>
                visibility_off
              </i>
            )}
          </div>
          <Field
            name={name}
            type={passwordVisibility ? 'text' : 'password'}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            disabled={disabled}
            onChange={onChange}
            placeholder={placeholder}
            onFocus={onFocus} // ? Note: if obBlur is used it will not not display errors
            // onFocus={onFocus, onFocusFloat(name,value)}
            onKeyDown={onKeyDown}
            onBlur={onBlurFloat(name, value)}
            value={value}
            as='input'
            maxLength={maxLength}
            pattern={pattern}
            tabIndex={tabIndex}
          />
        </div>
      )
    case 'textarea':
      return (
        <div style={{ ...inputStyles, ...inputGradientColors }}>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <Field
            as='textarea'
            rows={rows}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            type={type}
            tabIndex={tabIndex}
          />
        </div>
      )
    case 'amount':
      return (
        <div style={{ ...inputStyles, ...inputGradientColors }}>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <NeoNumber
            onKeyPress={onkeypress}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            onChange={onChange}
            value={value}
            disabled={disabled}
            tabIndex={tabIndex}
          />
        </div>
      )

    case 'onlyNumber':
      return (
        <div style={{ ...inputStyles, ...inputGradientColors }}>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <NeoOnlyNumber
            maxLength={maxLength}
            placeholder={placeholder}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            onChange={onChange}
            value={value}
            disabled={disabled}
            tabIndex={tabIndex}
          />
        </div>
      )

    case 'password':
      return (
        <div style={{ ...inputStyles, ...inputGradientColors }}>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <NeoPassword
            maxLength={maxLength}
            minLength={minLength}
            placeholder={placeholder}
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            onChange={onChange}
            value={value}
            disabled={disabled}
            tabIndex={tabIndex}
          />
        </div>
      )
    case 'maskedInput':
      return (
        <div style={{ ...inputStyles, ...inputGradientColors }}>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          <NeoIdentityType
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            onChange={onChange}
            value={value}
            tabIndex={tabIndex}
          />
        </div>
      )

    case 'maskedInput1':
      return (
        <div
          className='form-group colored-input'
          style={{ ...inputStyles, ...inputGradientColors }}>
          <div className='prefix'>
            <i className='material-icons'>{icon}</i>
          </div>
          <span id={`floatingLabel${name}`} className='floating-label font-weight-500'>
            {placeholder}
          </span>
          <NeoIdentityType
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            onChange={onChange}
            value={value}
            // placeholder={placeholder}
            onFocus={onFocusFloat(name, value)}
            onBlur={onBlurFloat(name, value)}
            tabIndex={tabIndex}
          />
        </div>
      )
    case 'customSelect':
      return (
        <div>
          <label className='control-label'>
            {text} {showAsterisk ? '*' : ''}
          </label>
          {/* <Field
            as='select'
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            name={name}
            disabled={disabled}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={onChange}>
            <option disabled selected value='' />
            {waitCondition ? (
              list.map((item, i) => (
                <option key={i} value={keyValue ? item[`${keyValue}`] : item}>
                  {keyValue ? item[`${keyValue}`] : item}
                </option>
              ))
            ) : (
              <option disabled value='' />
            )}
          </Field> */}
          <Select
            value={value}
            name={name}
            isSearchable='true'
            className={`form-control ${classes.inputText} ${classes.inputStyles}`}
            disabled={disabled}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={onChange}
            options={options}
            tabIndex={tabIndex}
          />
        </div>
      )
  }
}

export default NeoInput
